import React, { Fragment, useEffect, useRef, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import "./Sale.css";
import classNames from "classnames";
import { Menu, Transition } from "@headlessui/react";
import { emailLink } from "../../helpers/util";
import PrintIcon from "../../assets/img/printer.svg";
import ShareIcon from "../../assets/img/share.svg";
import DownloadIcon from "../../assets/img/download.svg";
import ThermalIcon from "../../assets/img/thermal3.svg";
import CheckIcon from "../../assets/img/check-circle.svg";
import { FaMailBulk, FaWhatsapp } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { AWS_URL, URL, http } from "../../services/http.service";
import {
  momentDateFormat,
  SaleformatDateByBusinessPreference,
} from "../../components/common/utlity/utility";
import { useNavigate, useParams } from "react-router-dom";
import { getHexTimeInSixDigit } from "../../components/common/utlity/sale.utility";
import { getCurrencySymbol } from "../../components/common/utlity/options";
import { useBusinessSettings } from "../../components/sidebar/BusinessSettingsContext";
import TallyPrime from "./Tally-prime";
import LandscapeTheme from "./LandscapeTheme";
import LandscapeTheme2 from "./LandscapeTheme2";
import GstTheme1 from "./GstTheme1";
import GstTheme2 from "./GstTheme2";
import GstTheme3 from "./GstTheme3";
import GstTheme4 from "./GstTheme4";
import Theme1 from "./Theme1";
import Theme2 from "./Theme2";
import Theme3 from "./Theme3";
import TaxInvoice1 from "./InvoiceDesign2";
import TaxInvoice2 from "./InvoiceDesign3";
import InvoiceDesign1 from "./InvoiceDesign1";
import DoubleDevine from "./DoubleDevine";
import GreenDoubleDevine from "./greenDoubledevine";
import ModernInvoice from "./ModernInvoice";
import ModernInvoice2 from "./MordernDesign2";
import useTheme from "../../constants/there";
import TraditionalInvoice from "./TraditionalInvoice";
import PDFStyleInvoice from "./pdfStyle";

const collectPageStyles = () => {
  let css = "";
  Array.from(document.querySelectorAll("style")).forEach((styleTag) => {
    css += styleTag.textContent || "";
  });
  Array.from(document.querySelectorAll('link[rel="stylesheet"]')).forEach((link) => {
    try {
      const sheet = link.sheet;
      if (!sheet) return;
      const rules = Array.from(sheet.cssRules || []);
      rules.forEach((rule) => {
        css += rule.cssText + "\n";
      });
    } catch (e) {
      // Cross-origin stylesheet — browser will still load it via <link>
    }
  });
  return css;
};

// Convert remote images (logo, QR, signature) to data URLs so html2canvas can
// draw them. no-store avoids a cached non-CORS response blocking the CORS fetch.
const inlineIframeImages = async (doc) => {
  const imgs = Array.from(doc.images).filter((img) => /^https?:/i.test(img.src));
  await Promise.all(
    imgs.map(async (img) => {
      try {
        const res = await fetch(img.src, { mode: "cors", cache: "no-store" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const blob = await res.blob();
        const dataUrl = await new Promise((resolve, reject) => {
          const fr = new FileReader();
          fr.onload = () => resolve(fr.result);
          fr.onerror = reject;
          fr.readAsDataURL(blob);
        });
        img.removeAttribute("srcset");
        await new Promise((resolve) => {
          img.onload = img.onerror = resolve;
          img.src = dataUrl;
        });
      } catch (e) {
        console.warn("Invoice image could not be inlined:", img.src, e);
      }
    }),
  );
};

// Build a fully standalone HTML document for the iframe.
const buildStandaloneHtml = ({ bodyHtml, pageWidthMm, pageRule }) => {
  const inlinedCss = collectPageStyles();

  const linkTags = Array.from(
    document.querySelectorAll('link[rel="stylesheet"]')
  )
    .map((l) => `<link rel="stylesheet" href="${l.href}" />`)
    .join("\n");

  const thermalPx = pageWidthMm === 58 ? 384 : pageWidthMm === 80 ? 432 : null;

  return `<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  ${linkTags}
  <style>
    ${pageRule}

    html, body {
      margin: 0 !important;
      padding: 0 !important;
      background: #ffffff !important;
      width: ${thermalPx ? thermalPx + "px" : "210mm"};
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      font-family: 'Courier New', 'Menlo', monospace;
      overflow: visible !important;
    }
    body > * { box-sizing: border-box; }

    .thermal-invoice-root {
      width: ${thermalPx ? thermalPx + "px" : "100%"};
      background: #ffffff;
      color: #000000;
      padding: 6px ${thermalPx ? "8px" : "0"};
      font-variant-numeric: tabular-nums;
      text-rendering: geometricPrecision;
      overflow: visible !important;
    }
    .thermal-invoice-root table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
    }
    .thermal-invoice-root th,
    .thermal-invoice-root td {
      vertical-align: top;
      word-break: break-word;
      overflow-wrap: anywhere;
      padding: 2px 0;
    }
    .thermal-invoice-root table,
    .thermal-invoice-root thead,
    .thermal-invoice-root tbody,
    .thermal-invoice-root tr,
    .thermal-invoice-root th,
    .thermal-invoice-root td {
      box-sizing: border-box;
    }

    .thermal-invoice-root .break-words {
      word-break: break-word;
      overflow-wrap: anywhere;
    }

    @media print {
      .print\\:hidden { display: none !important; }
      ${
        thermalPx
          ? `html, body { width: 100% !important; max-width: 100% !important; }
      .thermal-invoice-root {
        width: 100% !important;
        max-width: 100% !important;
        padding: 0 !important;
        box-sizing: border-box !important;
        overflow: hidden !important;
      }
      .thermal-invoice-root * { max-width: 100% !important; box-sizing: border-box; }
      .thermal-invoice-root img { height: auto; }`
          : ""
      }
    }

    ${inlinedCss}
  </style>
</head>
<body>
  <div class="thermal-invoice-root">
    ${bodyHtml}
  </div>
</body>
</html>`;
};

const SaleInvoice = ({
  close,
  item,
  returnInvoce = false,
  productSections,
  autoShare = false,
  onAutoShareDone,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const { bussinessUuid } = useParams();
  const { settings } = useBusinessSettings();
  const businessData = useSelector((state) => state.bussiness.business);
  const business = Array.isArray(businessData)
    ? businessData.find(
        (b) =>
          b.bussinessUuid === item?.bussinessUuid ||
          b.bussinessUuid === bussinessUuid
      ) || businessData[0]
    : businessData;
  const currentBusinessUuid =
    bussinessUuid || item?.bussinessUuid || business?.bussinessUuid || "";
  const [selectedPrint, setSelectedPrint] = useState(() => {
    const saved = localStorage.getItem(
      `invoice_template_${currentBusinessUuid}`
    );
    return saved ? parseInt(saved, 10) : 2;
  });
  const [selectedColor, setSelectedColor] = useState(() => {
    return (
      localStorage.getItem(`invoice_color_${currentBusinessUuid}`) ||
      "bg-pink-400"
    );
  });
  
  // FIX: Ref to prevent multiple auto-share API calls
  const hasAutoShared = useRef(false);

  const colors = [
    "bg-green-400", "bg-pink-400", "bg-blue-400", "bg-yellow-400",
    "bg-red-400", "bg-cyan-600", "bg-sky-800", "bg-slate-600",
    "bg-gray-800", "bg-lime-300", "bg-blue-800", "bg-green-700",
    "bg-lime-800", "bg-red-500", "bg-purple-800", "bg-pink-500",
    "bg-amber-800", "bg-yellow-700", "bg-pink-700", "bg-yellow-200",
    "bg-fuchsia-500", "bg-rose-900", "bg-teal-800", "bg-emerald-900",
    "bg-cyan-900", "bg-white",
  ];
  const { themeMode } = useTheme();

  useEffect(() => {
    if (currentBusinessUuid) {
      localStorage.setItem(
        `invoice_template_${currentBusinessUuid}`,
        String(selectedPrint)
      );
    }
  }, [selectedPrint, currentBusinessUuid]);

  useEffect(() => {
    if (currentBusinessUuid) {
      localStorage.setItem(
        `invoice_color_${currentBusinessUuid}`,
        selectedColor
      );
    }
  }, [selectedColor, currentBusinessUuid]);

  // ------------------------------------------------------------------
  // Render the invoice into an offscreen iframe with real Tailwind
  // ------------------------------------------------------------------
  const renderInvoiceInIframe = async ({
    isThermal,
    pageWidthMm,
    pageRule,
  }) => {
    const containerElement = containerRef.current;
    if (!containerElement) throw new Error("Invoice container not found");

    const html = buildStandaloneHtml({
      bodyHtml: containerElement.innerHTML,
      pageWidthMm,
      pageRule,
    });

    const thermalPx = pageWidthMm === 58 ? 384 : pageWidthMm === 80 ? 432 : null;

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.left = "-10000px";
    iframe.style.top = "0";
    iframe.style.width = isThermal ? `${thermalPx}px` : "210mm";
    iframe.style.height = "2000px";
    iframe.style.border = "0";
    iframe.style.visibility = "hidden";
    document.body.appendChild(iframe);

    await new Promise((resolve) => {
      iframe.onload = resolve;
      iframe.contentDocument.open();
      iframe.contentDocument.write(html);
      iframe.contentDocument.close();
    });

    await inlineIframeImages(iframe.contentDocument);
    await new Promise((r) => setTimeout(r, 300));
    iframe.style.visibility = "visible";

    const root = iframe.contentDocument.body.querySelector(
      ".thermal-invoice-root"
    );
    if (!root) {
      document.body.removeChild(iframe);
      throw new Error("Invoice root not rendered in iframe");
    }
    return { iframe, root };
  };

  // ------------------------------------------------------------------
  // BUILD PDF
  // ------------------------------------------------------------------
  const buildPdf = async () => {
    const isThermal = selectedPrint === 2 || selectedPrint === 3;
    const pageWidthMm = isThermal ? (selectedPrint === 2 ? 58 : 80) : null;
    const pageRule = isThermal
      ? `@page { size: ${pageWidthMm}mm auto; margin: 2mm; }`
      : `@page { size: A4; margin: 10mm; }`;

    let iframeEl;
    try {
      const { iframe, root } = await renderInvoiceInIframe({
        isThermal,
        pageWidthMm,
        pageRule,
      });
      iframeEl = iframe;

      const pad = isThermal ? 16 : 0;
      const canvas = await html2canvas(root, {
        scale: isThermal ? 4 : 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        windowWidth: root.scrollWidth + pad,
        windowHeight: root.scrollHeight,
        width: root.scrollWidth + pad,
        height: root.scrollHeight,
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.95);

      if (isThermal) {
        const pxPerMm = canvas.width / pageWidthMm;
        const pageHeightMm = canvas.height / pxPerMm;
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: [pageWidthMm, pageHeightMm],
          compress: true,
        });
        pdf.addImage(imgData, "JPEG", 0, 0, pageWidthMm, pageHeightMm);
        return pdf;
      }

      const pdf = new jsPDF("p", "mm", "a4");
      const pdfW = 210;
      const pdfH = 297;
      const imgW = pdfW - 10;
      const imgH = (canvas.height * imgW) / canvas.width;
      let heightLeft = imgH;
      let position = 0;
      pdf.addImage(imgData, "JPEG", 5, position, imgW, imgH);
      heightLeft -= pdfH;
      while (heightLeft > 0) {
        pdf.addPage();
        position -= pdfH;
        pdf.addImage(imgData, "JPEG", 5, position, imgW, imgH);
        heightLeft -= pdfH;
      }
      return pdf;
    } catch (err) {
      console.error("buildPdf error:", err);
      return null;
    } finally {
      if (iframeEl && iframeEl.parentNode)
        iframeEl.parentNode.removeChild(iframeEl);
    }
  };

  const download = async () => {
    const pdf = await buildPdf();
    if (!pdf) return;
    const filename =
      selectedPrint === 2
        ? "invoice-2in.pdf"
        : selectedPrint === 3
        ? "invoice-3in.pdf"
        : "invoice.pdf";
    pdf.save(filename);
  };

  // ------------------------------------------------------------------
  // PRINT
  // ------------------------------------------------------------------
  const printPage = async () => {
    const isThermal = selectedPrint === 2 || selectedPrint === 3;
    const pageWidthMm = isThermal ? (selectedPrint === 2 ? 58 : 80) : null;
    const pageRule = isThermal
      ? `@page { size: ${pageWidthMm}mm auto; margin: 2mm; }`
      : `@page { size: A4; margin: 10mm; }`;

    try {
      const { iframe } = await renderInvoiceInIframe({
        isThermal,
        pageWidthMm,
        pageRule,
      });
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      }, 1500);
    } catch (err) {
      console.error("printPage error:", err);
    }
  };

  const shareImage = async () => {
    const isThermal = selectedPrint === 2 || selectedPrint === 3;
    const pageWidthMm = isThermal ? (selectedPrint === 2 ? 58 : 80) : null;
    const pageRule = isThermal
      ? `@page { size: ${pageWidthMm}mm auto; margin: 2mm; }`
      : `@page { size: A4; margin: 10mm; }`;

    let iframeEl;
    try {
      const { iframe, root } = await renderInvoiceInIframe({
        isThermal,
        pageWidthMm,
        pageRule,
      });
      iframeEl = iframe;

      const pad = isThermal ? 16 : 0;
      const canvas = await html2canvas(root, {
        scale: isThermal ? 4 : 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        windowWidth: root.scrollWidth + pad,
        windowHeight: root.scrollHeight,
        width: root.scrollWidth + pad,
        height: root.scrollHeight,
      });

      await new Promise((resolve) => {
        canvas.toBlob(async (blob) => {
          if (!blob) return resolve();
          const formData = new FormData();
          formData.append("image", blob, `bill_${Date.now()}.png`);
          try {
            const response = await http.post(
              URL + "/uploadretailRocket/upload",
              formData
            );
            const ImageUrl = response.data.imageUrl;
            if (ImageUrl) {
              const msg = `Check out your bill: ${ImageUrl}`;
              window.open(
                `https://api.whatsapp.com/send?text=${encodeURIComponent(msg)}`,
                "_blank"
              );
            }
          } catch (e) {
            console.error("Upload error:", e);
          }
          resolve();
        }, "image/png");
      });
    } catch (err) {
      console.error("shareImage error:", err);
    } finally {
      if (iframeEl && iframeEl.parentNode)
        iframeEl.parentNode.removeChild(iframeEl);
    }
  };

  // FIX: Updated useEffect to prevent multiple API hits
  useEffect(() => {
    if (!autoShare || !item?.sellUuid || hasAutoShared.current) return undefined;
    
    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        hasAutoShared.current = true; // Mark as shared immediately so it doesn't trigger again
        const pdf = await buildPdf();
        if (!pdf || cancelled) throw new Error("PDF generation failed");
        const formData = new FormData();
        formData.append(
          "invoice",
          pdf.output("blob"),
          `invoice-${item.sellUuid}.pdf`
        );
        await http.post(
          `${URL}/sale/${
            item.bussinessUuid || currentBusinessUuid
          }/invoice-pdf/${item.sellUuid}`,
          formData
        );
      } catch (error) {
        console.error("Invoice share failed:", error);
      } finally {
        if (!cancelled) onAutoShareDone?.();
      }
    }, 1800);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item?.sellUuid, autoShare]);

  const userData = useSelector((state) => state.bussiness.business);
  const user = Array.isArray(userData)
    ? userData.find(
        (b) =>
          b.bussinessUuid === item?.bussinessUuid ||
          b.bussinessUuid === bussinessUuid
      ) || userData[0]
    : userData;

  const shareEmail = () => {
    const containerElement = containerRef?.current;
    let link = emailLink("https://dukkanbuddy.com/324234/sale", {
      subject: "Sale Invoice",
      body: containerElement.innerText,
      separator: " ",
    });
    window.open(link, "blank");
  };

  const {
    businessName,
    address,
    email,
    phone,
    gstNumber,
    pincode,
    aadharPhoto,
  } = user || {};
  const {
    invoiceId,
    mobile,
    deliveryAddress,
    gstNo,
    committedDateToPay,
    items,
    transactionAmount,
    subscriptionDisc,
    additionalFee,
    additionalDiscount,
    deliveryPreference,
    saleType,
    remainingTransactionAmount,
    pickupTime,
    pickupDate,
    igst,
    cgst,
    sgst,
    cess,
    intraState,
  } = item;

  const totalAdditionalDiscount = Array.isArray(additionalDiscount)
    ? additionalDiscount.reduce(
        (sum, d) => sum + (parseFloat(d.amount) || 0),
        0
      )
    : 0;

  const totalAdditionalFee = Array.isArray(additionalFee)
    ? additionalFee.reduce((sum, d) => sum + (parseFloat(d.amount) || 0), 0)
    : 0;

  const totalInvoiceAmount = item?.items?.reduce(
    (sum, i) => sum + parseFloat(i?.finalPrice || 0),
    0
  );

  const formatDueDate = (originalDate) => {
    const [year, month, day] = originalDate.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleNavigate = () => {
    navigate(`/${item?.bussinessUuid}/dashboard/profile`);
  };

  const formatVariantAttributes = (attributes) => {
    if (!attributes || attributes.length === 0) return "";
    return attributes.map((attr) => `${attr.name}: ${attr.value}`).join(", ");
  };

  // FIX: Replaced local ThermalIcon with remote URLs for the 2" and 3" options
  const printOptions = [
    { id: 2, label: `2” ${t("COMMON.THERMAL_PRINT")}`, image: 'https://i.postimg.cc/654Wdy4P/tally-Prime-page-0001.jpg' }, // Replace with your actual 2" thumbnail URL
    { id: 3, label: `3” ${t("COMMON.THERMAL_PRINT")}`, image: 'https://i.postimg.cc/654Wdy4P/tally-Prime-page-0001.jpg' }, // Replace with your actual 3" thumbnail URL
    { id: 4, label: t("INVOICENAME.TALLY_PRIME"), image: 'https://i.postimg.cc/654Wdy4P/tally-Prime-page-0001.jpg' },
    { id: 5, label: t("INVOICENAME.LANDSCAPE THEME 1"), image: 'https://i.postimg.cc/T3GVyytV/landscape-theme-page-0001.jpg' },
    { id: 6, label: t("INVOICENAME.LANDSCAPE THEME 2"), image: 'https://i.postimg.cc/VLssdmjS/landscape-theme2-page-0001.jpg' },
    { id: 7, label: t("INVOICENAME.GST_THEAME 1"), image: 'https://i.postimg.cc/c45cz1hw/gst-theme1-page-0001.jpg' },
    { id: 8, label: t("INVOICENAME.GST_THEAME 2"), image: 'https://i.postimg.cc/NjH0wb6b/gst-theme2-page-0001.jpg' },
    { id: 9, label: t("INVOICENAME.GST_THEAME 3"), image: 'https://i.postimg.cc/dVHg4Kkx/gst-theme3-page-0001.jpg' },
    { id: 10, label: t("INVOICENAME.GST_THEAME 4"), image: 'https://i.postimg.cc/c45cz1hw/gst-theme4-page-0001.jpg' },
    { id: 11, label: t("INVOICENAME.THEAME 1"), image: 'https://i.postimg.cc/c4mJ162t/theme1-page-0001.jpg' },
    { id: 12, label: t("INVOICENAME.THEAME 2"), image: 'https://i.postimg.cc/ZK3M6d40/theme2-page-0001.jpg' },
    { id: 13, label: t("INVOICENAME.THEAME 3"), image: 'https://i.postimg.cc/TwJPyw1s/theme3-page-0001.jpg' },
    { id: 14, label: t("INVOICENAME.THEAME 4"), image: 'https://i.postimg.cc/Mp3LrgfL/theme4a.png' },
    { id: 15, label: t("INVOICENAME.THEAME 5"), image: 'https://i.postimg.cc/3wJt71mv/theme5a.png' },
    { id: 16, label: t("INVOICENAME.THEAME 6"), image: 'https://i.postimg.cc/02zx5GGh/theme6a.png' },
    { id: 17, label: t("INVOICENAME.DOUBLE_DEVINE"), image: 'https://i.postimg.cc/pT54bkMB/devine.png', requiresNoReturn: true },
    { id: 18, label: t("INVOICE.Double Devine 2") || "Double Devine 2", image: 'https://i.postimg.cc/X7bFb4FD/Screenshot-2025-09-28-084358.png', requiresNoReturn: true },
    { id: 19, label: t("    MordenInvoice ") || "Modern Invoice", image: 'https://i.postimg.cc/kgyvZDpW/Screenshot-2025-09-28-084207.png', requiresNoReturn: true },
    { id: 20, label: t("    MordenInvoice2 ") || "Modern Invoice 2", image: 'https://i.postimg.cc/1RwRg0GY/Screenshot-2025-09-28-135802.png', requiresNoReturn: true },
    { id: 21, label: t("    TraditionalInvoice ") || "Traditional Invoice", image: 'https://i.postimg.cc/rp4pxzzH/Screenshot-2025-09-28-150310.png', requiresNoReturn: true },
    { id: 22, label: t("New Invoice") || "New Invoice", image: 'https://i.postimg.cc/rp4pxzzH/Screenshot-2025-09-28-150310.png', requiresNoReturn: true }
  ];

  const filteredPrintOptions = printOptions.filter(
    (option) => !option.requiresNoReturn || returnInvoce === false
  );

  const isThermalPrint = selectedPrint === 2 || selectedPrint === 3;

  return (
    <div className=' w-full flex '>
      <div className='w-2/3 '>
        {selectedPrint === 4 ? (
          <TallyPrime containerRef={containerRef} businessName={businessName} phone={phone} bussiness={user} item={item} darkMode={themeMode === "dark"} />
        ) : selectedPrint === 5 ? (
          <LandscapeTheme containerRef={containerRef} businessName={businessName} phone={phone} bussiness={user} item={item} darkMode={themeMode === "dark"} />
        ) : selectedPrint === 6 ? (
          <LandscapeTheme2 containerRef={containerRef} businessName={businessName} phone={phone} item={item} bussiness={user} darkMode={themeMode === "dark"} />
        ) : selectedPrint === 7 ? (
          <GstTheme1 containerRef={containerRef} businessName={businessName} phone={phone} item={item} bussiness={user} selectedColor={selectedColor} darkMode={themeMode === "dark"} />
        ) : selectedPrint === 8 ? (
          <GstTheme2 containerRef={containerRef} businessName={businessName} phone={phone} item={item} bussiness={user} selectedColor={selectedColor} darkMode={themeMode === "dark"} />
        ) : selectedPrint === 9 ? (
          <GstTheme3 containerRef={containerRef} businessName={businessName} phone={phone} item={item} bussiness={user} selectedColor={selectedColor} darkMode={themeMode === "dark"} />
        ) : selectedPrint === 10 ? (
          <GstTheme4 containerRef={containerRef} businessName={businessName} phone={phone} item={item} bussiness={user} selectedColor={selectedColor} darkMode={themeMode === "dark"} />
        ) : selectedPrint === 11 ? (
          <Theme1 containerRef={containerRef} businessName={businessName} phone={phone} item={item} bussiness={user} selectedColor={selectedColor} darkMode={themeMode === "dark"} />
        ) : selectedPrint === 12 ? (
          <Theme2 containerRef={containerRef} businessName={businessName} phone={phone} item={item} bussiness={user} selectedColor={selectedColor} darkMode={themeMode === "dark"} />
        ) : selectedPrint === 13 ? (
          <Theme3 containerRef={containerRef} businessName={businessName} phone={phone} item={item} bussiness={user} selectedColor={selectedColor} darkMode={themeMode === "dark"} />
        ) : selectedPrint === 14 ? (
          <TaxInvoice1 containerRef={containerRef} businessName={businessName} phone={phone} item={item} selectedColor={selectedColor} bussiness={user} />
        ) : selectedPrint === 15 ? (
          <TaxInvoice2 containerRef={containerRef} businessName={businessName} phone={phone} item={item} selectedColor={selectedColor} bussiness={user} />
        ) : selectedPrint === 16 ? (
          <InvoiceDesign1 containerRef={containerRef} businessName={businessName} phone={phone} item={item} selectedColor={selectedColor} bussiness={user} />
        ) : selectedPrint === 17 ? (
          <DoubleDevine containerRef={containerRef} businessName={businessName} phone={phone} item={item} bussiness={user} />
        ) : selectedPrint === 18 ? (
          <GreenDoubleDevine containerRef={containerRef} businessName={businessName} phone={phone} item={item} bussiness={user} />
        ) : selectedPrint === 19 ? (
          <ModernInvoice item={item} containerRef={containerRef} businessName={businessName} phone={phone} darkMode={false} bussiness={user} selectedColor={selectedColor} />
        ) : selectedPrint === 20 ? (
          <ModernInvoice2 item={item} containerRef={containerRef} businessName={businessName} phone={phone} darkMode={false} bussiness={user} selectedColor={selectedColor} />
        ) : selectedPrint === 21 ? (
          <TraditionalInvoice item={item} containerRef={containerRef} businessName={businessName} phone={phone} darkMode={false} bussiness={user} selectedColor={selectedColor} />
        ) : selectedPrint === 22 ? (
          <PDFStyleInvoice item={item} containerRef={containerRef} businessName={businessName} phone={phone} darkMode={false} bussiness={user} selectedColor={selectedColor} />
        ) : (
          <>
            {!address?.firstLine && (
              <div className='bg-yellow-100 dark:bg-yellow-900/40 border border-yellow-300 dark:border-yellow-700 rounded px-2 py-1 mb-2'>
                <button onClick={handleNavigate} className='text-[10px] font-semibold text-yellow-900 dark:text-yellow-100 underline'>
                  Click here to add your address for a better invoice.
                </button>
              </div>
            )}

            <div className='flex justify-center'>
              <div
                ref={containerRef}
                className={classNames(
                  'bg-white text-black font-mono leading-tight px-4 py-2 rounded-sm',
                  'border border-gray-200 dark:border-gray-700',
                  'dark:bg-gray-950 dark:text-gray-100'
                )}
                style={{
                  width: selectedPrint === 2 ? '380px' : '432px',
                  maxWidth: '100%',
                  overflowX: 'hidden',
                  boxSizing: 'border-box',
                }}
              >
                {/* HEADER */}
                <div className='text-center pb-1'>
                  <div className='flex justify-between items-start'>
                    <div className='text-[9px] font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400'>
                      {returnInvoce
                        ? 'RETURN / DEBIT NOTE'
                        : item?.saleType === 'estimate'
                        ? 'ESTIMATE'
                        : item?.saleType === 'advancePayment'
                        ? 'PROFORMA'
                        : 'TAX INVOICE'}
                    </div>
                    <button
                      className='text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 print:hidden'
                      onClick={() => close(false, item.saleType === 'estimate')}
                      aria-label='Close'
                    >
                      <RxCross2 size={14} />
                    </button>
                  </div>

                  <h1
                    className='text-sm font-black tracking-tight mt-1 break-words'
                    style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                  >
                    {businessName || 'Business Name'}
                  </h1>

                  <p
                    className='text-[10px] text-gray-600 dark:text-gray-400 mt-0.5 break-words'
                    style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                  >
                    {[address?.firstLine, address?.city, pincode]
                      .filter(Boolean)
                      .join(', ') || 'Address not available'}
                  </p>

                  <p className='text-[10px] text-gray-600 dark:text-gray-400'>
                    {phone ? `Ph: ${phone}` : ''}
                    {phone && email ? ' · ' : ''}
                    {email || ''}
                  </p>

                  {gstNumber && (
                    <p className='text-[10px] font-semibold text-gray-700 dark:text-gray-300 mt-0.5'>
                      GSTIN: {gstNumber}
                    </p>
                  )}

                  {item?.showGST === false && saleType !== 'estimate' && (
                    <p className='text-[9px] italic text-red-600 dark:text-red-400 mt-0.5'>
                      Non-GST Invoice — not valid for GST returns
                    </p>
                  )}
                </div>

                <div className='border-t border-dashed border-gray-400 dark:border-gray-600 my-1.5' />

                {/* INVOICE META */}
                <div className='text-[10px] space-y-0.5'>
                  <div className='flex justify-between'>
                    <span className='text-gray-500 dark:text-gray-400'>Invoice #</span>
                    <span className='font-semibold'>{invoiceId || getHexTimeInSixDigit()}</span>
                  </div>
                  <div className='flex justify-between'>
                    <span className='text-gray-500 dark:text-gray-400'>Date</span>
                    <span className='font-semibold'>
                      {SaleformatDateByBusinessPreference(item?.saleDate, business?.dateFormat)}
                    </span>
                  </div>
                  {committedDateToPay && (
                    <div className='flex justify-between'>
                      <span className='text-gray-500 dark:text-gray-400'>Due</span>
                      <span className='font-semibold text-red-600 dark:text-red-400'>
                        {formatDueDate(committedDateToPay)}
                      </span>
                    </div>
                  )}
                  {item?.ewayBillNo && (
                    <div className='flex justify-between'>
                      <span className='text-gray-500 dark:text-gray-400'>E-Way</span>
                      <span className='font-semibold'>{item.ewayBillNo}</span>
                    </div>
                  )}
                  {item?.validUpto && (
                    <div className='flex justify-between'>
                      <span className='text-gray-500 dark:text-gray-400'>Valid Upto</span>
                      <span className='font-semibold'>{item.validUpto}</span>
                    </div>
                  )}
                </div>

                <div className='border-t border-dashed border-gray-400 dark:border-gray-600 my-1.5' />

                {/* CUSTOMER */}
                <div className='text-[10px] space-y-0.5'>
                  <div className='flex justify-between gap-2'>
                    <span className='text-gray-500 dark:text-gray-400 shrink-0'>Customer</span>
                    <span
                      className='font-semibold text-right max-w-[60%] break-words'
                      style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                    >
                      {item?.customerName || 'Walk-in'}
                    </span>
                  </div>
                  {mobile && (
                    <div className='flex justify-between'>
                      <span className='text-gray-500 dark:text-gray-400'>Mobile</span>
                      <span className='font-semibold'>{mobile}</span>
                    </div>
                  )}
                  {item?.address && (
                    <div className='flex justify-between gap-2'>
                      <span className='text-gray-500 dark:text-gray-400 shrink-0'>Address</span>
                      <span
                        className='text-right break-words'
                        style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                      >
                        {item.address}
                        {item?.state ? `, ${item.state}` : ''}
                        {item?.country ? `, ${item.country}` : ''}
                      </span>
                    </div>
                  )}
                  <div className='flex justify-between'>
                    <span className='text-gray-500 dark:text-gray-400'>GSTIN</span>
                    <span className='font-semibold'>{gstNo || 'No-GST'}</span>
                  </div>
                  {deliveryAddress && (
                    <div className='flex justify-between gap-2'>
                      <span className='text-gray-500 dark:text-gray-400 shrink-0'>Deliver To</span>
                      <span
                        className='text-right break-words'
                        style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                      >
                        {deliveryAddress}
                      </span>
                    </div>
                  )}
                </div>

                <div className='border-t border-dashed border-gray-400 dark:border-gray-600 my-1.5' />

                {/* ITEMS */}
                {item.saleType === 'advancePayment' && items?.length <= 0 ? (
                  <p className='text-[10px] italic text-center py-1'>Items will be decided later</p>
                ) : isThermalPrint ? (
                  /* ---------- THERMAL: LINE-BASED LAYOUT (no table) ---------- */
                  <div className='text-[10px] tabular-nums'>
                    {returnInvoce === true ? (
                      (item?.returnitems || []).length > 0 ? (
                        item.returnitems.map((data, index) => (
                          <div
                            key={`ret-${index}`}
                            className='py-1 border-b border-dotted border-gray-300 dark:border-gray-700 last:border-b-0'
                          >
                            <div
                              className='font-semibold break-words'
                              style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                            >
                              {index + 1}. {data.productName}
                            </div>
                            {data.variantName && (
                              <div
                                className='text-[9px] text-gray-500 dark:text-gray-400 break-words'
                                style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                              >
                                {data.variantName}
                              </div>
                            )}
                            <div className='flex justify-between text-[9px] text-gray-600 dark:text-gray-400 mt-0.5'>
                              <span>
                                {data.quantity} × {getCurrencySymbol(business?.currency)}
                                {Number(data.salePrice || 0).toFixed(2)}
                              </span>
                              <span>
                                {intraState
                                  ? `IGST ${data.igst || 0}%`
                                  : `GST ${(data.cgst || 0) + (data.sgst_utgst || 0)}%`}
                                {data.discount ? ` · Dis ${data.discount}` : ''}
                              </span>
                            </div>
                            <div className='flex justify-between font-semibold text-[10px] mt-0.5'>
                              <span>Amount</span>
                              <span>
                                {getCurrencySymbol(business?.currency)}
                                {Number(data.finalPrice || 0).toFixed(2)}
                              </span>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className='text-center py-2 italic text-gray-500'>No return items</p>
                      )
                    ) : items?.length > 0 ? (
                      items.map((data, index) => {
                        const taxPct = intraState
                          ? Number(data.igst || 0)
                          : Number(data.cgst || 0) + Number(data.sgst_utgst || 0);
                        const rate =
                          data.salePrice ??
                          (data.quantity ? Number(data.finalPrice || 0) / data.quantity : 0);
                        return (
                          <div
                            key={`${data.productId}-${data.variantId || 'nv'}-${index}`}
                            className='py-1 border-b border-dotted border-gray-300 dark:border-gray-700 last:border-b-0'
                          >
                            <div
                              className='font-semibold break-words'
                              style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                            >
                              {index + 1}. {data.productName}
                            </div>
                            {data.variantName && (
                              <div
                                className='text-[9px] text-gray-500 dark:text-gray-400 break-words'
                                style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                              >
                                {data.variantName}
                                {data.attributes?.length > 0 && (
                                  <span className='block'>
                                    {formatVariantAttributes(data.attributes)}
                                  </span>
                                )}
                              </div>
                            )}
                            <div className='flex justify-between text-[9px] text-gray-600 dark:text-gray-400 mt-0.5'>
                              <span>
                                {data.quantity} × {getCurrencySymbol(business?.currency)}
                                {Number(rate).toFixed(2)}
                              </span>
                              <span>
                                {taxPct ? `${taxPct}% GST` : 'No GST'}
                                {data.discount
                                  ? ` · Dis ${data.discount}${
                                      data.discountUnit === 'percentage' ? '%' : ''
                                    }`
                                  : ''}
                              </span>
                            </div>
                            <div className='flex justify-between font-semibold text-[10px] mt-0.5'>
                              <span>Amount</span>
                              <span>
                                {getCurrencySymbol(business?.currency)}
                                {Number(data.finalPrice || 0).toFixed(2)}
                              </span>
                            </div>
                          </div>
                        );
                      })
                    ) : productSections.length > 0 ? (
                      productSections.map((data, index) => (
                        <div
                          key={`ps-${index}`}
                          className='py-1 border-b border-dotted border-gray-300 dark:border-gray-700 last:border-b-0'
                        >
                          <div
                            className='font-semibold break-words'
                            style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                          >
                            {index + 1}. {data.productName}
                          </div>
                          {data.variantName && (
                            <div
                              className='text-[9px] text-gray-500 dark:text-gray-400 break-words'
                              style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                            >
                              {data.variantName}
                            </div>
                          )}
                          <div className='flex justify-between text-[9px] text-gray-600 dark:text-gray-400 mt-0.5'>
                            <span>
                              {data.quantity} × {getCurrencySymbol(business?.currency)}
                              {Number(data.salePrice || 0).toFixed(2)}
                            </span>
                            <span>
                              {data.gstPercent ? `${data.gstPercent}% GST` : 'No GST'}
                              {data.discount ? ` · Dis ${data.discount}` : ''}
                            </span>
                          </div>
                          <div className='flex justify-between font-semibold text-[10px] mt-0.5'>
                            <span>Amount</span>
                            <span>
                              {getCurrencySymbol(business?.currency)}
                              {Number(data.finalPrice || 0).toFixed(2)}
                            </span>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className='text-center py-2 italic text-gray-500'>No items available</p>
                    )}
                  </div>
                ) : (
                  /* ---------- A4: TABLE LAYOUT ---------- */
                  <table
                    className='w-full text-[10px] tabular-nums'
                    style={{ width: '100%' }}
                  >
                    <colgroup>
                      <col style={{ width: '4%' }} />
                      <col />
                      <col style={{ width: '8%' }} />
                      <col style={{ width: '12%' }} />
                      <col style={{ width: '8%' }} />
                      <col style={{ width: '8%' }} />
                      <col style={{ width: '14%' }} />
                    </colgroup>
                    <thead>
                      <tr className='text-[9px] uppercase text-gray-500 dark:text-gray-400'>
                        <th className='text-left font-semibold pb-1'>#</th>
                        <th className='text-left font-semibold pb-1'>Item</th>
                        <th className='text-right font-semibold pb-1'>Qty</th>
                        <th className='text-right font-semibold pb-1'>Rate</th>
                        <th className='text-right font-semibold pb-1'>Dis</th>
                        <th className='text-right font-semibold pb-1'>Tax</th>
                        <th className='text-right font-semibold pb-1'>Amt</th>
                      </tr>
                    </thead>
                    <tbody>
                      {returnInvoce === true ? (
                        (item?.returnitems || []).length > 0 ? (
                          item.returnitems.map((data, index) => (
                            <tr
                              key={`ret-${index}`}
                              className='align-top border-t border-dotted border-gray-300 dark:border-gray-700'
                            >
                              <td className='py-1'>{index + 1}</td>
                              <td className='py-1 pr-1'>
                                <div
                                  className='font-semibold break-words'
                                  style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                                >
                                  {data.productName}
                                </div>
                                {data.variantName && (
                                  <div
                                    className='text-[9px] text-gray-500 dark:text-gray-400 break-words'
                                    style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                                  >
                                    {data.variantName}
                                  </div>
                                )}
                              </td>
                              <td className='py-1 text-right'>{data.quantity}</td>
                              <td className='py-1 text-right'>
                                {getCurrencySymbol(business?.currency)}
                                {Number(data.salePrice || 0).toFixed(2)}
                              </td>
                              <td className='py-1 text-right'>{data.discount ? `${data.discount}` : '—'}</td>
                              <td className='py-1 text-right'>
                                {intraState
                                  ? `${data.igst || 0}%`
                                  : `${(data.cgst || 0) + (data.sgst_utgst || 0)}%`}
                              </td>
                              <td className='py-1 text-right font-semibold'>
                                {getCurrencySymbol(business?.currency)}
                                {Number(data.finalPrice || 0).toFixed(2)}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan='7' className='text-center py-2 italic text-gray-500'>No return items</td>
                          </tr>
                        )
                      ) : items?.length > 0 ? (
                        items.map((data, index) => {
                          const taxPct = intraState
                            ? Number(data.igst || 0)
                            : Number(data.cgst || 0) + Number(data.sgst_utgst || 0);
                          const rate =
                            data.salePrice ??
                            (data.quantity ? Number(data.finalPrice || 0) / data.quantity : 0);
                          return (
                            <tr
                              key={`${data.productId}-${data.variantId || 'nv'}-${index}`}
                              className='align-top border-t border-dotted border-gray-300 dark:border-gray-700'
                            >
                              <td className='py-1'>{index + 1}</td>
                              <td className='py-1 pr-1'>
                                <div
                                  className='font-semibold break-words'
                                  style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                                >
                                  {data.productName}
                                </div>
                                {data.variantName && (
                                  <div
                                    className='text-[9px] text-gray-500 dark:text-gray-400 break-words'
                                    style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                                  >
                                    {data.variantName}
                                    {data.attributes?.length > 0 && (
                                      <span className='block'>
                                        {formatVariantAttributes(data.attributes)}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </td>
                              <td className='py-1 text-right'>{data.quantity}</td>
                              <td className='py-1 text-right'>
                                {getCurrencySymbol(business?.currency)}
                                {Number(rate).toFixed(2)}
                              </td>
                              <td className='py-1 text-right'>
                                {data.discount
                                  ? `${data.discount}${data.discountUnit === 'percentage' ? '%' : ''}`
                                  : '—'}
                              </td>
                              <td className='py-1 text-right'>{taxPct ? `${taxPct}%` : '—'}</td>
                              <td className='py-1 text-right font-semibold'>
                                {getCurrencySymbol(business?.currency)}
                                {Number(data.finalPrice || 0).toFixed(2)}
                              </td>
                            </tr>
                          );
                        })
                      ) : productSections.length > 0 ? (
                        productSections.map((data, index) => (
                          <tr
                            key={`ps-${index}`}
                            className='align-top border-t border-dotted border-gray-300 dark:border-gray-700'
                          >
                            <td className='py-1'>{index + 1}</td>
                            <td className='py-1 pr-1'>
                              <div
                                className='font-semibold break-words'
                                style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                              >
                                {data.productName}
                              </div>
                              {data.variantName && (
                                <div
                                  className='text-[9px] text-gray-500 dark:text-gray-400 break-words'
                                  style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                                >
                                  {data.variantName}
                                </div>
                              )}
                            </td>
                            <td className='py-1 text-right'>{data.quantity}</td>
                            <td className='py-1 text-right'>
                              {getCurrencySymbol(business?.currency)}
                              {Number(data.salePrice || 0).toFixed(2)}
                            </td>
                            <td className='py-1 text-right'>{data.discount ? `${data.discount}` : '—'}</td>
                            <td className='py-1 text-right'>{data.gstPercent ? `${data.gstPercent}%` : '—'}</td>
                            <td className='py-1 text-right font-semibold'>
                              {getCurrencySymbol(business?.currency)}
                              {Number(data.finalPrice || 0).toFixed(2)}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan='7' className='text-center py-2 italic text-gray-500'>No items available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}

                <div className='border-t border-dashed border-gray-400 dark:border-gray-600 my-1.5' />

                {/* TOTALS */}
                <div className='text-[10px] tabular-nums space-y-0.5'>
                  {item?.orderCouponDiscount > 0 && (
                    <div className='flex justify-between'>
                      <span className='text-gray-500 dark:text-gray-400'>
                        Coupon {item?.orderCouponName ? `(${item.orderCouponName})` : ''}
                      </span>
                      <span className='font-semibold text-green-700 dark:text-green-400'>
                        − {getCurrencySymbol(business?.currency)}{Number(item.orderCouponDiscount).toFixed(2)}
                      </span>
                    </div>
                  )}
                  {totalAdditionalFee > 0 && (
                    <div className='flex justify-between'>
                      <span className='text-gray-500 dark:text-gray-400'>Additional Fee</span>
                      <span className='font-semibold'>
                        {getCurrencySymbol(business?.currency)}{Number(totalAdditionalFee).toFixed(2)}
                      </span>
                    </div>
                  )}
                  {totalAdditionalDiscount > 0 && (
                    <div className='flex justify-between'>
                      <span className='text-gray-500 dark:text-gray-400'>Additional Discount</span>
                      <span className='font-semibold text-green-700 dark:text-green-400'>
                        − {getCurrencySymbol(business?.currency)}{Number(totalAdditionalDiscount).toFixed(2)}
                      </span>
                    </div>
                  )}
                  {subscriptionDisc > 0 && (
                    <div className='flex justify-between'>
                      <span className='text-gray-500 dark:text-gray-400'>Subscription Savings</span>
                      <span className='font-semibold text-green-700 dark:text-green-400'>
                        − {getCurrencySymbol(business?.currency)}{Number(subscriptionDisc).toFixed(2)}
                      </span>
                    </div>
                  )}
                  {intraState === true ? (
                    igst ? (
                      <div className='flex justify-between'>
                        <span className='text-gray-500 dark:text-gray-400'>IGST</span>
                        <span>{getCurrencySymbol(business?.currency)}{Number(igst).toFixed(2)}</span>
                      </div>
                    ) : null
                  ) : (
                    <>
                      {cgst ? (
                        <div className='flex justify-between'>
                          <span className='text-gray-500 dark:text-gray-400'>CGST</span>
                          <span>{getCurrencySymbol(business?.currency)}{Number(cgst).toFixed(2)}</span>
                        </div>
                      ) : null}
                      {sgst ? (
                        <div className='flex justify-between'>
                          <span className='text-gray-500 dark:text-gray-400'>SGST</span>
                          <span>{getCurrencySymbol(business?.currency)}{Number(sgst).toFixed(2)}</span>
                        </div>
                      ) : null}
                    </>
                  )}
                  {cess ? (
                    <div className='flex justify-between'>
                      <span className='text-gray-500 dark:text-gray-400'>Cess</span>
                      <span>{getCurrencySymbol(business?.currency)}{Number(cess).toFixed(2)}</span>
                    </div>
                  ) : null}
                  {(item?.saleType === 'advancePayment' || item?.saleType === 'advanceSale') &&
                    Number(item?.advancePayment) > 0 && (
                      <div className='flex justify-between'>
                        <span className='text-gray-500 dark:text-gray-400'>Advance Paid</span>
                        <span className='font-semibold'>
                          {getCurrencySymbol(business?.currency)}{Number(item.advancePayment).toFixed(2)}
                        </span>
                      </div>
                    )}
                  {remainingTransactionAmount > 0 && (
                    <>
                      <div className='flex justify-between'>
                        <span className='text-gray-500 dark:text-gray-400'>Paid</span>
                        <span className='font-semibold'>
                          {getCurrencySymbol(business?.currency)}
                          {(Number(transactionAmount || 0) - Number(remainingTransactionAmount || 0)).toFixed(2)}
                        </span>
                      </div>
                      <div className='flex justify-between'>
                        <span className='text-gray-500 dark:text-gray-400'>Balance Due</span>
                        <span className='font-semibold text-red-600 dark:text-red-400'>
                          {getCurrencySymbol(business?.currency)}{Number(remainingTransactionAmount).toFixed(2)}
                        </span>
                      </div>
                    </>
                  )}
                </div>

                {/* GRAND TOTAL */}
                <div className='border-t-2 border-double border-gray-700 dark:border-gray-300 mt-1.5 pt-1.5'>
                  <div className='flex justify-between items-baseline text-xs font-black'>
                    <span className='uppercase tracking-wide'>
                      {item?.saleType === 'advancePayment' ? 'Balance' : 'Total'}
                    </span>
                    <span className='tabular-nums'>
                      {getCurrencySymbol(business?.currency)}
                      {returnInvoce === true
                        ? Number(item?.totalReturnAmount || 0).toFixed(2)
                        : Number(
                            subscriptionDisc
                              ? transactionAmount
                              : item?.advancePayment
                              ? item?.transactionAmount
                              : totalInvoiceAmount - Number(item?.advancePayment || 0)
                          ).toFixed(2)}
                    </span>
                  </div>
                </div>

                {/* DELIVERY / PICKUP */}
                {(saleType === 'homeDelivery' || (saleType === 'shedulePickup' && pickupDate)) && (
                  <>
                    <div className='border-t border-dashed border-gray-400 dark:border-gray-600 my-1.5' />
                    <div className='text-[9px] text-gray-600 dark:text-gray-400 space-y-0.5'>
                      {saleType === 'homeDelivery' && deliveryPreference?.deliveryDate && (
                        <div className='flex justify-between'>
                          <span>Expected Delivery</span>
                          <span>{momentDateFormat(deliveryPreference.deliveryDate)}</span>
                        </div>
                      )}
                      {saleType === 'shedulePickup' && (
                        <>
                          <div className='flex justify-between'>
                            <span>Pickup Date</span>
                            <span>{momentDateFormat(pickupDate)}</span>
                          </div>
                          {pickupTime && (
                            <div className='flex justify-between'>
                              <span>Pickup Time</span>
                              <span>{pickupTime}</span>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}

                {/* QR */}
                {business?.aadharPhoto && (
                  <>
                    <div className='border-t border-dashed border-gray-400 dark:border-gray-600 my-1.5' />
                    <div className='flex flex-col items-center pt-1'>
                      <img src={AWS_URL + business.aadharPhoto} alt='Payment QR' className='w-24 h-24 object-contain' />
                      <p className='text-[9px] text-gray-500 dark:text-gray-400 mt-0.5'>Scan to pay</p>
                    </div>
                  </>
                )}

                {/* NOTES & FOOTER */}
                {item?.notes && (
                  <>
                    <div className='border-t border-dashed border-gray-400 dark:border-gray-600 my-1.5' />
                    <p
                      className='text-[9px] text-gray-600 dark:text-gray-400 break-words'
                      style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                    >
                      <span className='font-semibold'>Note: </span>{item.notes}
                    </p>
                  </>
                )}

                <div className='border-t border-dashed border-gray-400 dark:border-gray-600 my-1.5' />
                <p className='text-center text-[9px] text-gray-500 dark:text-gray-400'>
                  Thank you for your business!
                </p>
                <p className='text-center text-[8px] text-gray-400 dark:text-gray-500 mt-0.5'>
                  Powered by DukkanBuddy
                </p>
              </div>
            </div>
          </>
        )}
      </div>

      <div className='w-1/3 p-4 bg-gray-50/30 dark:bg-[#0b0619]/40 border-l border-gray-200/80 dark:border-[#22163b]/70 flex flex-col h-[calc(100vh-60px)] min-h-0'>
        <style>{`
          .custom-scrollbar-invoice::-webkit-scrollbar { width: 5px; }
          .custom-scrollbar-invoice::-webkit-scrollbar-track { background: transparent; }
          .custom-scrollbar-invoice::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
          .dark .custom-scrollbar-invoice::-webkit-scrollbar-thumb { background: #334155; }
        `}</style>

        <div className='flex gap-2.5 pb-4 border-b border-gray-150 dark:border-gray-800/60'>
          <button
            className='flex-1 px-3 py-2 bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white font-medium rounded-xl flex items-center justify-center gap-1.5 transition-all duration-200 shadow-sm shadow-emerald-600/10 hover:shadow-lg hover:shadow-emerald-600/20 transform hover:-translate-y-0.5 active:translate-y-0 focus:outline-none'
            onClick={printPage}
            type="button"
          >
            <img src={PrintIcon} alt='' className='w-4.5 h-4.5 invert' />
            <span className='text-xs font-semibold'>{t("COMMON.PRINT")}</span>
          </button>

          <button
            className='flex-1 px-3 py-2 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-medium rounded-xl flex items-center justify-center gap-1.5 transition-all duration-200 shadow-sm shadow-blue-600/10 hover:shadow-lg hover:shadow-blue-600/20 transform hover:-translate-y-0.5 active:translate-y-0 focus:outline-none'
            onClick={download}
            type="button"
          >
            <img src={DownloadIcon} alt='' className='w-4.5 h-4.5 invert' />
            <span className='text-xs font-semibold'>{t("COMMON.DOWNLOAD")}</span>
          </button>

          <Menu as='div' className='relative flex'>
            <Menu.Button className='px-3 py-2 bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 text-white font-medium rounded-xl flex items-center justify-center gap-1.5 transition-all duration-200 shadow-sm shadow-indigo-600/10 hover:shadow-lg hover:shadow-indigo-600/20 transform hover:-translate-y-0.5 active:translate-y-0 focus:outline-none h-full' type="button">
              <img src={ShareIcon} alt='' className='w-4.5 h-4.5 invert' />
              <span className='text-xs font-semibold'>{t("COMMON.SHARE")}</span>
            </Menu.Button>
            <Transition
              as={Fragment}
              enter='transition ease-out duration-100'
              enterFrom='transform opacity-0 scale-95'
              enterTo='transform opacity-100 scale-100'
              leave='transition ease-in duration-75'
              leaveFrom='transform opacity-100 scale-100'
              leaveTo='transform opacity-0 scale-95'
            >
              <Menu.Items className='origin-top-right z-30 absolute right-0 mt-10 w-44 rounded-xl shadow-xl p-1 bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 focus:outline-none border border-gray-100 dark:border-gray-700'>
                {settings?.appSettings?.whatsappBilling !== false && (
                  <Menu.Item>
                    {({ active }) => (
                      <div
                        className={classNames(
                          "rounded-lg flex items-center px-3 py-2 text-xs font-medium cursor-pointer transition-colors gap-2",
                          active
                            ? "text-emerald-700 bg-emerald-50 dark:text-emerald-300 dark:bg-emerald-950/30"
                            : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/50"
                        )}
                        onClick={shareImage}
                      >
                        <FaWhatsapp className='text-emerald-600 text-sm' />
                        {t("COMMON.WHATSAPP")}
                      </div>
                    )}
                  </Menu.Item>
                )}
                <Menu.Item>
                  {({ active }) => (
                    <div
                      className={classNames(
                        "rounded-lg flex items-center px-3 py-2 text-xs font-medium cursor-pointer transition-colors gap-2",
                        active
                          ? "text-blue-700 bg-blue-50 dark:text-blue-300 dark:bg-blue-950/30"
                          : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/50"
                      )}
                      onClick={shareEmail}
                    >
                      <FaMailBulk className='text-blue-600 text-sm' />
                      {t("COMMON.EMAIL")}
                    </div>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>

        <div className='mt-4 p-3.5 bg-gradient-to-br from-indigo-50/60 to-blue-50/40 dark:from-indigo-950/20 dark:to-blue-950/10 rounded-2xl border border-indigo-100/50 dark:border-indigo-900/30 flex justify-between items-center shadow-sm'>
          <div className='min-w-0'>
            <p className='text-[10px] font-bold text-indigo-500 dark:text-indigo-400 uppercase tracking-wider'>
              {t("COMMON.CUSTOMER") || "Customer"}
            </p>
            <h4 className='font-bold text-gray-800 dark:text-white text-sm truncate mt-0.5'>
              {item?.customerName || "Walk-in Customer"}
            </h4>
          </div>
          <div className='text-right'>
            <p className='text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider'>
              {t("COMMON.TOTAL_AMOUNT") || "Total"}
            </p>
            <h4 className='font-bold text-gray-900 dark:text-white text-base mt-0.5'>
              {transactionAmount}
            </h4>
          </div>
        </div>

        <div className='flex flex-col gap-2 p-3 bg-white dark:bg-white/5 rounded-2xl border border-gray-150 dark:border-gray-800/40 mt-3 shadow-sm'>
          <div className='flex justify-between items-center px-0.5'>
            <span className='text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider'>
              {t("COMMON.CHOOSE_COLOR") || "Accent Color"}
            </span>
            <span className='text-[10px] font-medium text-gray-500 dark:text-gray-400 capitalize'>
              {selectedColor.replace('bg-', '').replace('-400', '').replace('-500', '').replace('-600', '').replace('-700', '').replace('-800', '')}
            </span>
          </div>
          <div className='flex flex-wrap gap-2 py-0.5 justify-start'>
            {colors.map((color, idx) => (
              <button
                key={idx}
                className={`${color} w-5 h-5 rounded-full cursor-pointer transition-all duration-200 hover:scale-110 active:scale-95 focus:outline-none relative
                  ${selectedColor === color ? "ring-2 ring-offset-2 ring-indigo-600 dark:ring-offset-gray-900" : "hover:ring-1 hover:ring-offset-1 hover:ring-gray-300 dark:hover:ring-offset-gray-800"}`}
                onClick={() => setSelectedColor(color)}
                aria-label={`Select accent color`}
                type="button"
              >
                {selectedColor === color && (
                  <span className="absolute inset-0 flex items-center justify-center text-white text-[10px] font-bold">✓</span>
                )}
              </button>
            ))}
          </div>
        </div>

        <div className='mt-4 flex flex-col gap-2.5 flex-1 min-h-0 overflow-y-auto pr-1.5 custom-scrollbar-invoice'>
          <div className='text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider px-1'>
            {t("INVOICE.SELECT_TEMPLATE") || "Print Templates"}
          </div>

          <div className='grid grid-cols-2 gap-3.5 pb-6'>
            {filteredPrintOptions.map((option) => (
              <div
                key={option.id}
                className={classNames(
                  "flex flex-col rounded-2xl overflow-hidden border cursor-pointer transition-all duration-305 group relative",
                  selectedPrint === option.id
                    ? "border-indigo-600 bg-indigo-50/10 dark:border-indigo-500 dark:bg-indigo-950/10 shadow-md shadow-indigo-600/5"
                    : "border-gray-150 bg-white hover:border-gray-300 dark:border-gray-850 dark:bg-gray-900 dark:hover:border-gray-805 shadow-sm"
                )}
                onClick={() => setSelectedPrint(option.id)}
              >
                {selectedPrint === option.id && (
                  <div className='absolute top-2 right-2 bg-indigo-600 dark:bg-indigo-500 rounded-full p-1 shadow-md z-10 flex items-center justify-center w-6 h-6 border border-white dark:border-gray-800 animate-scale-in'>
                    <img src={CheckIcon} alt='selected' className='w-3 h-3 invert' />
                  </div>
                )}

                <div className={classNames(
                  'h-30 flex items-center justify-center p-2 relative overflow-hidden transition-all duration-300',
                  selectedPrint === option.id ? 'bg-indigo-50/20 dark:bg-indigo-950/20' : 'bg-gray-50 dark:bg-gray-950/40'
                )}>
                  <img
                    src={option.image}
                    alt={option.label}
                    className='max-w-full max-h-full object-contain rounded transition-transform duration-300 group-hover:scale-105 filter drop-shadow-sm'
                    onError={(e) => { 
                      e.target.onerror = null; 
                      e.target.src = 'https://i.postimg.cc/654Wdy4P/tally-Prime-page-0001.jpg'; 
                    }}
                  />
                </div>

                <div className={classNames(
                  'p-2 text-center border-t text-[10px] font-bold truncate transition-colors',
                  selectedPrint === option.id
                    ? 'bg-indigo-600 text-white border-indigo-600 dark:bg-indigo-500 dark:border-indigo-500'
                    : 'bg-white text-gray-700 border-gray-100 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-800/80 group-hover:text-indigo-600 dark:group-hover:text-indigo-400'
                )}>
                  {option.label || option.labelFallback}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleInvoice;